import React from 'react';
import ConsentGuard from './ConsentGuard';

const MeteoblueWidgets: React.FC = () => {
  return (
    <div className="mt-8 space-y-8 flex flex-col items-center">
      {/* Widget 1: 3-Day Forecast */}
      <div className="w-full flex flex-col items-center">
        <div className="overflow-hidden rounded-lg shadow-md bg-white p-2" style={{ maxWidth: '460px', width: '100%' }}>
          <ConsentGuard title="Meteoblue Wetter-Widget">
            <iframe 
              src="https://www.meteoblue.com/en/weather/widget/three/bad-langensalza_germany_2953413?geoloc=fixed&nocurrent=0&noforecast=0&days=4&tempunit=CELSIUS&windunit=KILOMETER_PER_HOUR&layout=image&user_key=a88008b9f99c9728&embed_key=abddad2a5837bb0c&sig=5d83356c45615d0e780476ce1c5dd2d29f9b0c334ed35dc6da895e9babffc773" 
              frameBorder="0" 
              scrolling="NO" 
              allowTransparency={true} 
              sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox" 
              style={{ width: '100%', height: '574px', border: '0', overflow: 'hidden' }}
              title="meteoblue 3-day forecast"
            ></iframe>
          </ConsentGuard>
          <div className="text-right text-xs mt-1">
            <a href="https://www.meteoblue.com/en/weather/week/index" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              meteoblue
            </a>
          </div>
        </div>
      </div>

      {/* Widget 2: Weather Map */}
      <div className="w-full max-w-4xl">
        <div className="overflow-hidden rounded-lg shadow-md bg-white p-2">
          <ConsentGuard title="Meteoblue Wetterkarte">
            <iframe 
              src="https://www.meteoblue.com/en/weather/maps/widget/bad-langensalza_germany_2953413?windAnimation=1&gust=1&satellite=1&cloudsAndPrecipitation=1&temperature=1&sunshine=1&extremeForecastIndex=1&geoloc=fixed&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=9&autowidth=auto&user_key=a88008b9f99c9728&embed_key=1908763f8ac75466&sig=b60ce4ad6c34f54b2e06460b6da4412d7e17cdd5321bebea73e7ef2b05ccede2" 
              frameBorder="0" 
              scrolling="NO" 
              allowTransparency={true} 
              sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox" 
              style={{ width: '100%', height: '700px', border: '0', overflow: 'hidden' }}
              title="meteoblue weather map"
            ></iframe>
          </ConsentGuard>
          <div className="text-right text-xs mt-1">
            <a href="https://www.meteoblue.com/en/weather/week/index" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              meteoblue
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeteoblueWidgets;

